import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Link, { LinkProps } from '@material-ui/core/Link';

const styles = (theme) => ({
  root: {
    color: theme.palette.common.white,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.common.white,
      textDecoration: 'none',
    },
  },
});

type Props = Omit<LinkProps, 'underline' | 'target' | 'rel'>;

const FooterLink = (props: Props) => (
  <Link {...props} underline="none" target="_blank" rel="noopener" />
);

export default withStyles(styles)(FooterLink);
